import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { Modal, Table } from 'antd';
import moment from 'moment';

const TransferHistory = props => {
  const { fabricTransferHistory, transferHistoryModal, hideModal } = props;

  const status = useMemo(
    () => record => {
      if (record.approvedAt) {
        return 'Approved';
      }
      if (record.rejectedAt) {
        return 'Rejected';
      }
      return null;
    },
    []
  );

  const respondDateColumn = useMemo(
    () => record => {
      if (record.approvedAt) {
        return record.approvedAt
          ? moment(record.approvedAt).format('DD MMM YYYY')
          : null;
      }
      if (record.rejectedAt) {
        return record.rejectedAt
          ? moment(record.rejectedAt).format('DD MMM YYYY')
          : null;
      }
      return null;
    },
    []
  );

  const targetColumns = useMemo(
    () => [
      {
        title: 'Customer',
        dataIndex: 'targetCustomer',
      },
      {
        title: 'Product',
        dataIndex: 'targetProduct',
      },
      {
        title: 'BPO #',
        dataIndex: 'targetBpoNo',
      },
      {
        title: 'Fabric',
        dataIndex: 'target_fabric',
      },
      {
        title: 'Width',
        dataIndex: 'target_width',
      },
      {
        title: 'Color',
        children: [
          {
            title: 'Base',
            dataIndex: 'targetBaseColor',
          },
          {
            title: 'Print',
            dataIndex: 'targetPrintColor',
          },
        ],
      },
      {
        title: 'Factory',
        dataIndex: 'targetFactory',
      },
      {
        title: 'Rack #',
        dataIndex: 'targetRackno',
      },
      {
        title: 'Quantity',
        children: [
          {
            title: 'Requested',
            dataIndex: 'requestedQuantity',
          },
          {
            title: 'Transfered',
            dataIndex: 'transferredQuantity',
          },
        ],
      },
      {
        title: 'Status',
        dataIndex: 'status',
        render: (_text, record) => status(record),
      },
      {
        title: 'Request',
        children: [
          {
            title: 'Remark',
            dataIndex: 'requestedRemark',
          },
          {
            title: 'By',
            dataIndex: 'requestedBy',
          },
          {
            title: 'Date',
            dataIndex: 'requestedAt',
            render: requestedAt =>
              requestedAt ? moment(requestedAt).format('DD MMM YYYY') : null,
          },
        ],
      },
      {
        title: 'Respond',
        children: [
          {
            title: 'Remark',
            dataIndex: 'respondedRemark',
          },
          {
            title: 'By',
            dataIndex: 'respondedBy',
          },
          {
            title: 'Date',
            dataIndex: 'requestedAt',
            render: (_text, record) => respondDateColumn(record),
          },
        ],
      },
    ],
    []
  );

  const rowKey = useMemo(() => record => record.id, []);

  const scroll = useMemo(() => ({ x: 2000 }), []);

  return (
    <>
      <Modal
        onCancel={hideModal}
        visible={transferHistoryModal}
        maskClosable={false}
        width="100%"
        footer={false}
        style={{ top: 10 }}
      >
        <Table
          bordered
          size="small"
          columns={targetColumns}
          dataSource={fabricTransferHistory}
          rowKey={rowKey}
          pagination={false}
          scroll={scroll}
        />
      </Modal>
    </>
  );
};

TransferHistory.propTypes = {
  fabricTransferHistory: PropTypes.array,
  transferHistoryModal: PropTypes.bool,
  hideModal: PropTypes.func,
};

export default TransferHistory;
